import { all } from 'redux-saga/effects';
import LayoutSaga from './layout/saga';
import loginSaga from './login/saga';
import ForgetPasswordSaga from './forgetPwd/saga';
import addUserSaga from './CognitoUser/saga';
import organizationSaga from './organization/saga';
import orgAccountSaga from './orgAcct/saga';
import globalLicenseSaga from './globalLicense/saga';
import customLicenseSaga from './customLicense/saga';
import globalIaacSaga from './globalIaac/saga';
import organizationIaacSaga from './organizationIaac/saga';
import orgUsersSaga from "./orgUsers/saga";
import malwareScanSaga from "./malwareScan/saga";
import freeLicenseSaga from "./freeLicense/saga";
import organizationBillingSaga from './organizationBilling/saga';
import organizationBillingUsageSaga from './organizationBillingUsage/saga';

export default function* rootSaga() {
    yield all([
        LayoutSaga(),
        loginSaga(),
        ForgetPasswordSaga(),
        addUserSaga(),
        organizationSaga(),
        orgAccountSaga(),
        globalLicenseSaga(),
        customLicenseSaga(),
        globalIaacSaga(),
        organizationIaacSaga(),
        orgUsersSaga(),
        malwareScanSaga(),
        freeLicenseSaga(),
        organizationBillingSaga(),
        organizationBillingUsageSaga(),
    ]);
}